export const getSeriesValue = (serie) => {
    if (serie && typeof serie === 'object') {
        return serie.serie || serie.Serie || serie.codigo || serie.noSerie || serie.numeroSerie || '';
    }

    return `${serie ?? ''}`.trim();
};

export const normalizeSeriesItem = (serie, fallbackIdArticulo = null) => {
    if (serie && typeof serie === 'object') {
        return {
            idSerie: serie.idSerie ?? null,
            idArticulo: serie.idArticulo ?? fallbackIdArticulo,
            serie: getSeriesValue(serie),
            seleccion: serie.seleccion ?? false,
            fechaActivo: serie.fechaActivo ?? null,
            altaIntelisis: serie.altaIntelisis ?? null
        };
    }

    return {
        idSerie: null,
        idArticulo: fallbackIdArticulo,
        serie: getSeriesValue(serie),
        seleccion: false,
        fechaActivo: null,
        altaIntelisis: null
    };
};

export const normalizeSeriesList = (seriesValue, fallbackIdArticulo = null) => {
    if (Array.isArray(seriesValue)) {
        return seriesValue
            .flatMap((serie) => {
                if (serie && typeof serie === 'object') {
                    return [serie];
                }

                return `${serie ?? ''}`.split(',');
            })
            .map((serie) => normalizeSeriesItem(serie, fallbackIdArticulo))
            .filter((serie) => Boolean(serie.serie));
    }

    if (seriesValue === undefined || seriesValue === null) {
        return [];
    }

    return `${seriesValue}`
        .split(',')
        .map((serie) => normalizeSeriesItem(serie, fallbackIdArticulo))
        .filter((serie) => Boolean(serie.serie));
};

export const buildProductSeriesKey = (idFactura, idArticulo) => `${idFactura}-${idArticulo}`;

export const normalizeProjectCompleteDetail = (response, fallbackInvoices = [], fallbackProjectData = {}) => {
    const invoicesMetadataMap = new Map(
        (fallbackInvoices || []).map((invoice) => [`${invoice.idFactura}`, invoice])
    );
    const normalizedInvoicesMap = new Map();
    const normalizedProductsByInvoice = {};
    const productSeriesMap = {};

    const artAndSeries = Array.isArray(response?.artAndSeries) ? response.artAndSeries : [];
    const projectDetails = response?.projectDetails || {};

    artAndSeries.forEach((item) => {
        const articulos = Array.isArray(item?.articulos) ? item.articulos : [];

        articulos.forEach((articulo) => {
            const idFactura = articulo?.idFactura;
            const idArticulo = articulo?.idArticulo;

            if (!idFactura || !idArticulo) {
                return;
            }

            const invoiceMetadata = invoicesMetadataMap.get(`${idFactura}`) || {};
            const productKey = buildProductSeriesKey(idFactura, idArticulo);
            const normalizedSeries = normalizeSeriesList(item?.series, idArticulo);
            const normalizedProduct = {
                ...articulo,
                idFactura,
                idArticulo,
                factura: invoiceMetadata?.factura || articulo?.factura || `${idFactura}`,
                fechaActivo: invoiceMetadata?.fechaActivo || articulo?.fechaActivo || null,
                descripcion: articulo?.descripcion || '',
                importe: articulo?.importe ?? articulo?.precioPedido ?? articulo?.precioUnitario ?? 0,
                precio: articulo?.importe ?? articulo?.precioPedido ?? articulo?.precioUnitario ?? 0,
                precioUnitario: articulo?.precioUnitario ?? articulo?.importe ?? articulo?.precioPedido ?? 0
            };

            productSeriesMap[productKey] = normalizedSeries;

            if (!normalizedProductsByInvoice[idFactura]) {
                normalizedProductsByInvoice[idFactura] = [];
            }

            normalizedProductsByInvoice[idFactura].push(normalizedProduct);

            if (!normalizedInvoicesMap.has(`${idFactura}`)) {
                normalizedInvoicesMap.set(`${idFactura}`, {
                    idFactura,
                    factura: invoiceMetadata?.factura || articulo?.factura || `${idFactura}`,
                    fechaActivo: invoiceMetadata?.fechaActivo || articulo?.fechaActivo || null,
                    cliente: invoiceMetadata?.cliente || fallbackProjectData?.cliente || projectDetails?.cliente || ''
                });
            }
        });
    });

    return {
        projectDetails,
        invoices: Array.from(normalizedInvoicesMap.values()),
        productsByInvoice: normalizedProductsByInvoice,
        productSeriesMap
    };
};
